"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const react_jss_1 = __importDefault(require("react-jss"));
const react_router_dom_1 = require("react-router-dom");
const classnames_1 = __importDefault(require("classnames"));
const logic = __importStar(require("./GameLogic"));
const GameBoard_1 = __importDefault(require("./GameBoard"));
const Button_1 = __importDefault(require("./components/Button"));
const Timer_1 = __importDefault(require("./components/Timer"));
const logo_svg_1 = __importDefault(require("../svg/logo.svg"));
const GameConstants_1 = require("./GameConstants");
const star_svg_1 = __importDefault(require("../svg/star.svg"));
const Boop_1 = __importDefault(require("./components/Boop"));
const styles = {
    background: {
        // background: '#EEEEEE',
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        // zIndex: -1,
    },
    wrapper: {
        width: 380,
        justifyContent: "center",
        display: "inline-block",
        background: "#EEEEEE",
        boxShadow: "0px 1px 2px #0006",
        borderRadius: 5,
        padding: 10,
    },
    logo: {
        boxSizing: "border-box",
        width: "100%",
        marginTop: 20,
        marginBottom: 30,
    },
    pauseButton: {
        position: "absolute",
        left: 0,
        top: 0,
        margin: 20,
        fontWeight: "bold",
        fontSize: 35,
    },
    button: {
        margin: 5,
        fontSize: 30,
    },
    winModalHeader: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "2px 10px",
        borderRadius: 5,
        position: "relative",
        backgroundColor: "rgba(255,255,255,0.4)",
        boxShadow: "2px 2px 4px grey",
        margin: 10,
        // height: 50,
        fontSize: 30,
        cursor: "text",
        fontFamily: "Bubblegum Sans",
        gap: "5px",
    },
    winModalScores: {
        fontSize: 20,
        cursor: "text",
        fontFamily: "Bubblegum Sans",
        textAlign: "center",
        display: "flex",
        gap: "10px",
        flexDirection: "row",
        alignItems: "baseline",
        justifyContent: "center",
    },
    turnField: {
        background: "white",
        display: "flex",
        flexDirection: "row",
        marginTop: 10,
        padding: 10,
        borderRadius: 5,
        // boxShadow: '2px 2px 4px grey',
        // boxShadow: '0px 1px 2px #0006',
        justifyContent: "space-between",
        alignItems: "center",
        "& > span": {
            fontFamily: "Bubblegum Sans, cursive",
            fontSize: 30,
            /* font-weight: 400, */
            margin: 10,
            textShadow: "0px 1px 2px #0009",
        },
    },
    player1: {
        color: "var(--p1-color)",
        flex: 1,
    },
    player2: {
        color: "var(--p2-color)",
        flex: 1,
        textAlign: "right",
    },
    activePlayer: {
        outline: "5px solid #b0e0df",
    },
    score: {
        width: "40%",
    },
    scoreLeft: {
        textAlign: "end",
    },
    scoreRight: {
        textAlign: "start",
    },
    star: {
        width: 40,
        height: 40,
    },
};
const pauseModalStyles = {
    content: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        inset: 0,
        padding: "20px 80px",
    },
    overlay: {
        background: "#0004",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
    },
};
const winModalStyles = {
    content: {
        padding: 5,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        inset: 0,
        alignSelf: "center",
    },
    overlay: {
        // background: 'var(--tiffany-extra-dark)',
        background: "#0009",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        zIndex: 1,
        paddingTop: 10,
    },
};
class Game extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = Object.assign({ scores: { P1: 0, P2: 0 } }, this.defaultState());
        this.handlePause = () => {
            this.setState({ isPaused: true });
        };
        this.handleResume = () => {
            this.setState({ isPaused: false });
        };
        this.placeTokenAtX = (x) => {
            const y = this.state.grid[x].indexOf(null);
            // Ignore if column already full
            // Bail early, don't count as turn
            if (y === -1)
                return;
            const grid = this.state.grid;
            grid[x][y] = this.activePlayer;
            this.checkWinCondition(grid, x, y);
            this.setState({
                turnCounter: this.state.turnCounter + 1,
                grid,
            });
        };
        this.handleClick = (x) => () => {
            if (this.activePlayer !== this.props.player) {
                return;
            }
            this.placeTokenAtX(x);
            if (this.props.gameMode === "private_multiplayer") {
                this.props.onPlaceToken(x);
            }
            else {
                setTimeout(this.robMove, 2000);
            }
        };
        this.checkWinCondition = (grid, x, y) => {
            const winSequences = logic.checkWinCondition(grid, x, y);
            if (winSequences.length) {
                const { scores } = this.state;
                scores[this.activePlayer]++;
                this.setState({
                    winningPlayerID: this.activePlayer,
                    winSequences,
                    scores,
                });
            }
        };
        this.robMove = () => {
            if (this.state.winningPlayerID !== null)
                return;
            const gridCopy = JSON.parse(JSON.stringify(this.state.grid));
            // First check if Rob can win anywhere,
            // then check if he can block anywhere
            for (const player of ["P2", "P1"]) {
                for (let x = 0; x < GameConstants_1.NUM_COLUMNS; x++) {
                    const y = gridCopy[x].indexOf(null);
                    if (y === -1)
                        continue;
                    gridCopy[x][y] = player;
                    if (logic.checkWinCondition(gridCopy, x, y).length) {
                        this.placeTokenAtX(x);
                        return;
                    }
                    gridCopy[x][y] = null;
                }
            }
            this.placeRandomToken();
        };
        this.placeRandomToken = () => {
            const nonFullColumns = this.state.grid
                .map((cells, i) => ({ cells, i }))
                .filter(({ cells }) => cells.includes(null));
            const randomX = nonFullColumns[Math.floor(Math.random() * nonFullColumns.length)].i;
            this.placeTokenAtX(randomX);
            return randomX;
        };
        this.handleNewGame = () => {
            this.setState(Object.assign(Object.assign({}, this.state), this.defaultState()));
        };
        this.handleTimeout = () => {
            const x = this.placeRandomToken();
            if (this.props.gameMode === "private_multiplayer") {
                this.props.onPlaceToken(x);
            }
            else {
                setTimeout(this.robMove, 2000);
            }
        };
    }
    defaultState() {
        return {
            isPaused: false,
            turnCounter: 0,
            grid: Array.from(Array(GameConstants_1.NUM_COLUMNS), () => new Array(GameConstants_1.NUM_ROWS).fill(null)),
            winSequences: [],
            winningPlayerID: null,
        };
    }
    get activePlayer() {
        return GameConstants_1.PLAYERS[this.state.turnCounter % 2];
    }
    componentDidUpdate(prevProps) {
        const tokenPlaced = this.props.tokenPlaced;
        console.log(this.props, prevProps);
        if (tokenPlaced.i >= 0 && tokenPlaced.i !== prevProps.tokenPlaced.i) {
            this.placeTokenAtX(tokenPlaced.x);
        }
    }
    render() {
        const { classes, players } = this.props;
        const { winningPlayerID, winSequences, turnCounter, scores, grid } = this.state;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(react_modal_1.default, { isOpen: this.state.isPaused, onRequestClose: this.handleResume, style: pauseModalStyles },
                react_1.default.createElement(Button_1.default, { className: classes.button, onClick: this.handleResume }, "Resume"),
                react_1.default.createElement(Button_1.default, { className: classes.button, Component: react_router_dom_1.Link, to: "/" }, "Back to menu")),
            react_1.default.createElement(react_modal_1.default, { isOpen: winningPlayerID !== null, onRequestClose: this.handleResume, style: winModalStyles },
                react_1.default.createElement("div", { className: classes.winModalHeader },
                    players[winningPlayerID],
                    " won",
                    react_1.default.createElement(Boop_1.default, { rotation: 20, timing: 200 }, winningPlayerID === this.props.player && (react_1.default.createElement(star_svg_1.default, { className: classes.star })))),
                react_1.default.createElement("div", { className: classes.winModalScores },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.score, classes.scoreLeft) },
                        players.P1,
                        " ",
                        scores.P1),
                    react_1.default.createElement("div", null, ":"),
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.score, classes.scoreRight) },
                        scores.P2,
                        " ",
                        players.P2)),
                react_1.default.createElement(Button_1.default, { className: classes.button, onClick: this.handleNewGame }, "Play again"),
                react_1.default.createElement(Button_1.default, { className: classes.button, Component: react_router_dom_1.Link, to: "/" }, "Back to main menu")),
            react_1.default.createElement("div", { className: classes.background },
                react_1.default.createElement(Button_1.default, { className: classes.pauseButton, onClick: this.handlePause }, "| |"),
                react_1.default.createElement("div", { className: classes.wrapper },
                    react_1.default.createElement(logo_svg_1.default, { className: classes.logo }),
                    react_1.default.createElement(GameBoard_1.default, { grid: grid, winSequences: winSequences, onClick: this.handleClick }),
                    react_1.default.createElement("div", { className: classes.turnField },
                        react_1.default.createElement("span", { className: (0, classnames_1.default)(classes.player1, {
                                [classes.activePlayer]: this.activePlayer === "P1",
                            }) }, players.P1),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(Timer_1.default, { isPaused: this.state.isPaused || winningPlayerID !== null, onTimeOut: this.handleTimeout, turnCounter: turnCounter })),
                        react_1.default.createElement("span", { className: (0, classnames_1.default)(classes.player2, {
                                [classes.activePlayer]: this.activePlayer === "P2",
                            }) }, players.P2))))));
    }
}
exports.default = (0, react_jss_1.default)(styles)(Game);
